import { PLAN_BUILDER_INTERNET_URL } from "@/lib/clickthrough-destination";

import type { NavBarType } from "./types";

export const OFFERS_NAVIGATION = {
  orderCta: {
    show: {
      mobile: true,
      tablet: true,
      desktop: true,
    },
    icon: "IconCart",
    showIcon: {
      mobile: false,
      tablet: true,
      desktop: true,
    },
    copy: "Order online",
    url: PLAN_BUILDER_INTERNET_URL,
    elementName: "ctaButtonNavOrderOnline",
    tagularProps: {
      location: "header",
      actionOutcome: "sentToLocalize",
    },
  },
  signIn: {
    copy: "Sign In",
    url: "https://login.xfinity.com/login",
    elementName: "textLinkNavSignIn",
    tagularProps: {
      location: "header",
    },
  },
  topBar: {
    show: {
      mobile: false,
      tablet: false,
      desktop: false,
    },
    eyebrow: "",
    copy: "",
    cta: {
      copy: "Order online",
      url: PLAN_BUILDER_INTERNET_URL,
    },
    prePhoneCopy: " or call ",
  },
} satisfies NavBarType;
